/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeIcon20Regular = forwardRef('SearchLoupeIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 1.502a7.498 7.498 0 1 0 4.745 13.303l3.526 3.526a.75.75 0 0 0 1.06-1.06l-3.525-3.526A7.498 7.498 0 0 0 9 1.503ZM3.002 9a5.998 5.998 0 1 1 11.996 0A5.998 5.998 0 0 1 3.002 9Z" })));
});
